import { nullish, object } from 'valibot'
import { singleImage, singleLineData } from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'

export const literatureSchema = crystallizeDocumentSchema(
  'literature',
  object({
    cover: singleImage,
    title: nullish(singleLineData),
    edition: nullish(singleLineData),
  }),
)
